export const COMMON_SET_PERSONALITIES = 'COMMON_SET_PERSONALITIES'
export const COMMON_SET_CURRENCIES = 'COMMON_SET_CURRENCIES'

export default {
  [COMMON_SET_PERSONALITIES]: (state, personalities) => {
    state.personalities = personalities
  },
  [COMMON_SET_CURRENCIES]: (state, currencies) => {
    state.currencies = currencies
  }
}
